import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function Tomos() {
  const features = ['6 Tomos', '3 Bonos', 'Más de 450 páginas', 'Acceso inmediato', 'Compatible con cualquier dispositivo'];
  return <section className="py-20 md:py-32 px-4 relative" data-id="element-269">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold/20 to-transparent" data-id="element-270" />

      <div className="max-w-6xl mx-auto" data-id="element-271">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-272">
          <h2 className="text-3xl md:text-5xl font-heading font-bold mb-6 text-white" data-id="element-273">
            ¿Qué incluye este Megapack?
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16" data-id="element-274">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-8" data-id="element-275">
            <div data-id="element-276">
              <h3 className="text-2xl font-bold text-gold mb-2" data-id="element-277">
                6 Tomos exclusivos
              </h3>
              <p className="text-text-secondary text-lg" data-id="element-278">
                Más de 300 páginas de contenido cuidadosamente organizado para
                que explores la historia de Roma desde sus orígenes hasta su
                legado.
              </p>
            </div>
            <div data-id="element-279">
              <h3 className="text-2xl font-bold text-gold mb-2" data-id="element-280">
                3 Bonos Premium
              </h3>
              <p className="text-text-secondary text-lg" data-id="element-281">
                Material adicional repleto de curiosidades, mapas y misterios
                para ampliar la experiencia.
              </p>
            </div>
            <div data-id="element-282">
              <h3 className="text-2xl font-bold text-gold mb-2" data-id="element-283">
                Formato Digital
              </h3>
              <p className="text-text-secondary text-lg" data-id="element-284">
                Accedé desde computadora, celular o tablet.
                <br data-id="element-285" />
                Leé a tu ritmo, donde quieras y cuando quieras.
              </p>
            </div>

            <div className="bg-dark-card border border-dark-border rounded-xl p-6 mt-8" data-id="element-286">
              <ul className="space-y-3" data-id="element-287">
                {features.map((feature, idx) => <li key={idx} className="flex items-center gap-3 text-text-main font-medium" data-id="element-288">
                    <CheckCircle2 className="w-5 h-5 text-gold shrink-0" data-id="element-289" />
                    {feature}
                  </li>)}
              </ul>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="flex flex-col items-center" data-id="element-290">
            <img src="https://cdn.magicpatterns.com/uploads/iXWQ4d8Rx7segFx8qZ967v/ChatGPT_Image_7_jul_2026,_20_30_57_-_Editado.png" alt="Megapack Imperio Romano Legendario" className="w-full max-w-lg drop-shadow-[0_0_30px_rgba(201,164,76,0.2)] mb-8" data-id="element-291" />

            <motion.a href="#oferta-premium" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="inline-flex items-center justify-center w-full sm:w-auto px-8 py-4 bg-gradient-to-r from-gold to-gold-light text-dark font-bold text-base md:text-lg rounded-lg shadow-[0_0_30px_rgba(201,164,76,0.3)] hover:shadow-[0_0_40px_rgba(201,164,76,0.5)] transition-all animate-pulse-slow" data-id="element-292">
              QUIERO MI MEGAPACK AHORA
            </motion.a>
          </motion.div>
        </div>
      </div>
    </section>;
}